import { testCurrensy } from "../../tempDB"
import { IImages } from "../characters/Character"
import { initItem, Item, TItem } from "../items/Item"

export interface ICurrensy {
    images: IImages,
    name: string,
    amount: number
}

export interface ICurrensies {
    [id: string]: ICurrensy
}

interface IInventoryItems {
    items: Item[]
    currencies: ICurrensies
}

export const initInventory: IInventoryItems = {
    items: [],
    currencies: testCurrensy
}

export default class Inventory {
    private items: Item[]
    private currencies: ICurrensies

    constructor(initItems: IInventoryItems) {
        this.items = [...initItems.items]
        this.currencies = { ...initItems.currencies }
    }

    pushInInventory(item: Item, itemCount: number = 1) {
        const itemComeType: TItem = item.getType()
        const itemComeIsStackable: boolean = item.getStackable()

        if (this.getItems().length) {
            let isWeHaveItemTypeLikeCome: boolean = false
            let isItemWeHaveStackable: boolean = false

            let itemToStack: Item = new Item(initItem)

            this.getItems().forEach(item => {
                if (item.getType() === itemComeType) {
                    isWeHaveItemTypeLikeCome = true

                    if (isWeHaveItemTypeLikeCome && item.getStackable()) {
                        isItemWeHaveStackable = true
                        itemToStack = item
                    }
                }
            })

            if (!isWeHaveItemTypeLikeCome) {
                this.items.push(item)
            }

            if (isWeHaveItemTypeLikeCome && !itemComeIsStackable && !isItemWeHaveStackable) {
                this.items.push(item)
            }

            if (isWeHaveItemTypeLikeCome && itemComeIsStackable && isItemWeHaveStackable) {
                itemToStack.setCount(itemToStack.getCount() + itemCount)
            }
        } else {
            this.items.push(item)
        }
    }

    setInventory(newItems: Item[]) {
        this.items = newItems
    }

    getItems() {
        return this.items
    }

    deleteFromInventory(index: number) {
        this.items.splice(index, 1)
    }

    getCurrensies() {
        return this.currencies
    }

    pushToCurrencies(item: ICurrensy) {
        if (this.currencies[item.name])
            this.currencies[item.name].amount += item.amount
        else
            this.currencies[item.name] = item
    }

}